import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './InputGroup.styles';

export const positionEnum = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

const InputGroup = ({ children, position, spacing, className }) => {
  const classes = useStyles();

  return (
    <span className={`${classes.inputGroup} ${className}`} style={{ gap: `${spacing}rem`, justifyContent: position }}>
      {children}
    </span>
  );
};

InputGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  position: PropTypes.oneOf(Object.values(positionEnum)),
  spacing: PropTypes.number,
};

InputGroup.defaultProps = {
  className: '',
  position: positionEnum.center,
  spacing: 1,
};

export default React.memo(InputGroup);
